<template>
    <v-row class="main-row-fill-height">
        <!-- <v-col cols="3" class="py-0">
            <v-card max-height="100%" height="100%" color="grey lighten-3" style="overflow: auto;">
                <v-navigation-drawer width="100%" height="100%" style="padding-top: 70px;">
                    <v-toolbar absolute flat color="primary" width="100%" height="70px" dark>
                        <v-toolbar-title>Funktionsauswahl</v-toolbar-title>
                    </v-toolbar>
                    <v-list class="pt-0">
                        <v-list-item-group v-model="active" color="grey darken-4">
                            <v-list-item 
                                :style="active === index ? 'pointer-events: none' : ''"
                                v-for="(item, index) in getFuncItems"
                                :key="index"
                            >
                                <v-list-item-content>
                                    <div class="subtitle-1 d-flex align-center justify-space-between">
                                        {{ item.displayText }}
                                        <v-icon v-if="item.completed()" color="success" class="ml-4">mdi-check-circle</v-icon>
                                    </div>
                                </v-list-item-content>
                            </v-list-item>
                        </v-list-item-group>
                    </v-list>
                </v-navigation-drawer>
            </v-card>
        </v-col> -->
        <v-col cols="9" class="pa-0 pos-rel pad-b">
            <div class="top-bar pl-14 pr-10 py-8" ref="topBar">
                <div class="content">
                    <div class="text-section">
                        <h2 class="mb-2 menu-title">{{$t('funktionsauswahl')}}</h2>
                        <p class="ma-0 menu-description">{{$t('funktionsauswahlDescription')}}</p>
                        <p 
                        v-show="getSubNavActiveId.mainNavActiveId == 1 
                        && (getSubNavActiveId.subNavActiveId == 8 || getSubNavActiveId.subNavActiveId == 9)" 
                        class="ma-0">
                            {{$t('funktionPanikAndFluchtDescription')}}
                        </p>
                    </div>
                    <a href="javascript:void(0)" @click="toggleResources = !toggleResources"
                        class="resources-holder" v-if="showResources">
                        <div class="resources" :class="{ 'active': toggleResources }">
                            <div class="resources-placeholders">
                                <p class="menu-description">{{$t('resourcesLabel')}}</p>
                                <p class="font-weight-bold menu-title"><span>0</span> {{$t('documentsLabel')}}, <span>{{numberOfShownImages}}</span> {{$t('imagesLabel')}}</p>
                            </div>
                            <div class="pl-5 dropdown-icon">
                                <v-icon class="icon-class">mdi-menu-down</v-icon>
                            </div>
                        </div>
<!--                              <transition name="slide-fade">-->
<!--                                  <div class="resources-dropdown" v-if="toggleResources">-->
<!--                                      <div class="resources-placeholders">-->
<!--                                          <p>{{$t('resourcesLabel')}}</p>-->
<!--                                          <p class="font-weight-bold"><span>0</span> {{$t('documentsLabel')}}, <span>0</span> {{$t('imagesLabel')}}-->
<!--                                          </p>-->
<!--                                      </div>-->
<!--                                  </div>-->
<!--                              </transition>-->
                        <transition name="slide-fade">
                                    <div class="resources-dropdown" v-if="toggleResources">
                                        <div class="resources-placeholders">
                                            <p class="menu-description">{{$t('resourcesLabel')}}</p>
                                            <p class="font-weight-bold menu-title"><span>0</span> {{$t('documentsLabel')}}, <span>{{numberOfShownImages}}</span> {{$t('imagesLabel')}}
                                            </p>
                                        </div>
                                        <div class="resources-content">
                                            <div>
                                                <a href="javascript:void(0)" @click="toggleImageDialog = true">
                                                    <v-img
                                                        :src="zierleistenVariantBSImage.resourceLocation ? zierleistenVariantBSImage.resourceLocation : zierleistenVariantGBSImage.resourceLocation">
                                                    </v-img>
                                                </a>
                                            </div>
                                            <div>
                                                <a href="javascript:void(0)" @click="toggleImageDialog = true">
                                                    <v-img
                                                        :src="falzgeometrieImage.resourceLocation">
                                                    </v-img>
                                                </a>
                                            </div>
                                            <div>
                                                <a href="javascript:void(0)" @click="toggleImageDialog = true">
                                                    <v-img
                                                        :src="zierleistenArtImage.resourceLocation">
                                                    </v-img>
                                                </a>
                                            </div>
                                            <div>
                                                <a href="javascript:void(0)" @click="toggleImageDialog = true">
                                                    <v-img
                                                        :src="doorOpeningWayImage.resourceLocation">
                                                    </v-img>
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                        </transition>
                    </a>
                </div>   
            </div>
                    
            <v-divider></v-divider>

            <v-card data-simplebar flat :style="{'height': `calc(100% - ${bodyCalcHeight}px)`, 'max-height' : '100%'}" class="pa-8 pl-12 pt-6">
                <simplebar style="overflow-x: hidden;" class="px-2">
                    <template v-if="getSubNavActiveId.mainNavActiveId == 1 && getSubNavActiveId.subNavActiveId == 0">
                        <h3 class="font-weight-regular submenu-title">{{$t('aufgehrichtungTur')}}</h3>
                        <v-row>
                            <v-col md="6" sm="12">
                                <v-select dense outlined return-object :menu-props="{ offsetY: true }" item-text="description"
                                    :items="getCharacteristicAndValues('KTU_MM_AUFGEHRICHTUNG').values"
                                    :value="getRegisteredCharacteristicsValue('KTU_MM_AUFGEHRICHTUNG', functionsContext).value"
                                    @change="addCharacterisitc($event, getCharacteristicAndValues('KTU_MM_AUFGEHRICHTUNG'));">
                                </v-select>
                            </v-col>
                        </v-row>
                        <div class="text-center image_fc93ba86">
                            <a href="javascript:void(0)" @click="openImageDialogThree = true">
                                <v-img
                                    max-width="100%"
                                    class="mx-auto"
                                    contain
                                    :src="doorOpeningWayImage.resourceLocation" />
                            </a>
                        </div>
                    </template>
                    <template
                        v-else-if="getSubNavActiveId.mainNavActiveId == 1 && getSubNavActiveId.subNavActiveId == 1">
                        <h3 class="font-weight-regular submenu-title">{{ $t('auswahlMauerwerk') }}</h3>
                        <v-row>
                            <v-col class="col-6 offset-3 mt-5" style="margin-bottom: -25px;">
                                <v-select dense outlined return-object :menu-props="{ offsetY: true }"
                                    :items="changeDescriptionValue(getCharacteristicAndValues('KTU_MM_WANDART_BESTAND').values)" item-text="description"
                                    :value="getRegisteredCharacteristicsValue('KTU_MM_WANDART_BESTAND', functionsContext).value"
                                    @change="addCharacterisitc($event, getCharacteristicAndValues('KTU_MM_WANDART_BESTAND'));filterDependencies('CUST_MM_MINDESTBESTANDSSTARKE')">
                                </v-select>
                            </v-col>

                            <v-col class="col-3 offset-3">
                                <div class="subtitle-2 mb-2" style="height: 50px; display:table-cell; vertical-align:bottom;">
                                    {{ $t('mindestbestandsstarke') }}</div>
                                <v-text-field dense outlined readonly
                                    class="unit-text-field"
                                    style="width:100% !important;"
                                    :value="getRegisteredCharacteristicsValue('CUST_MM_MINDESTBESTANDSSTARKE', functionsContext).value.description"
                                    suffix="mm"></v-text-field>
                            </v-col>
                            <v-col class="col-3">
                                <div class="subtitle-2 mb-2" style="height:50px; display:table-cell; vertical-align:bottom;">{{ $t('vorhandeneBestandsstarke') }}</div>
                                <v-text-field dense outlined suffix="mm"
                                style="width:100% !important;"
                                class="unit-text-field"
                                :rules="[KTU_MM_WANDDICKE_RULES.miniumValue(parseFloatFromGermanFloat(getRegisteredCharacteristicsValue('KTU_MM_WANDDICKE', functionsContext).value.value), parseInt(getRegisteredCharacteristicsValue('CUST_MM_MINDESTBESTANDSSTARKE', functionsContext).value.description))]"
                                v-model="wanddicke">
                                </v-text-field>
                            </v-col>
                        </v-row>
                        <div class="fit_image_a70d4293">
                            <div class="text-center image_a70d4293">
                                <a href="javascript:void(0)" @click="openImageDialog = true">
                                    <v-img max-width="100%" class="mx-auto" contain
                                           :src="getRegisteredCharacteristicsValue('KTU_MM_WANDART_BESTAND', functionsContext).value.resource" />
                                </a>
                            </div>
                        </div>
                    </template>
                    <template
                        v-else-if="getSubNavActiveId.mainNavActiveId == 1 && getSubNavActiveId.subNavActiveId == 2">
                        <h3 class="font-weight-regular mb-4 submenu-title">{{ $t('zusatzdichtungTitle') }}</h3>
                        <v-checkbox :disabled="getNrOfValuesByCharacteristic('CUST_MM_RH_DICHTUNG') < 2"
                            :input-value="getRegisteredCharacteristicsValue('CUST_MM_RH_DICHTUNG', functionsContext).value.value === 'JA'"
                            :label="getCharacteristicAndValues('CUST_MM_RH_DICHTUNG').description"
                            @change="checkBoxAdd('CUST_MM_RH_DICHTUNG')"></v-checkbox>
                    </template>
                    <template
                        v-else-if="getSubNavActiveId.mainNavActiveId == 1 && getSubNavActiveId.subNavActiveId == 3">
                        <h3 class="font-weight-regular mb-4 submenu-title">{{$t('zierleiste')}}</h3>
                        <v-row>
                            <v-col md="6" sm="12">
                                <div class="subtitle-2 mb-2">{{$t('zierleistenart')}}</div>
                                <v-select dense outlined return-object :menu-props="{ offsetY: true }"
                                    :items="getCharacteristicAndValues('KTU_MM_ZIERLEISTENART').values" item-text="description"
                                    :value="getRegisteredCharacteristicsValue('KTU_MM_ZIERLEISTENART', functionsContext).value"
                                    @change="addCharacterisitc($event, getCharacteristicAndValues('KTU_MM_ZIERLEISTENART'));
                                filterDependencies('KTU_MM_ZIERLEISTENVAR_BS');
                                filterDependencies('KTU_MM_ZIERLEISTENVAR_GBS');
                                filterDependencies('KTU_MM_ZIERLEISTEN');"></v-select>
                            </v-col>
                        </v-row>
                        <div class="text-center image_a0618669" :style="zierleistenArtImage.resourceLocation === '' ? 'display:none' : '' ">
                            <a href="javascript:void(0)" @click="openImageDialogSix = true">
                                <v-img max-width="75%" class="mx-auto" contain
                                       :src="zierleistenArtImage.resourceLocation" />
                            </a>
                        </div>
                        <v-divider class="mb-4"></v-divider>
                        <v-row>
                            <v-col cols="6">
                                <div class="subtitle-2 mb-2">{{$t('zierleisteVariantenBandseite')}}</div>
                                <v-select dense outlined return-object :menu-props="{ offsetY: true }"
                                    :items="getCharacteristicAndValues('KTU_MM_ZIERLEISTENVAR_BS').values"
                                    item-text="description"
                                    :value="getRegisteredCharacteristicsValue('KTU_MM_ZIERLEISTENVAR_BS', functionsContext).value"
                                    @change="addCharacterisitc($event, getCharacteristicAndValues('KTU_MM_ZIERLEISTENVAR_BS')); filterDependencies('KTU_MM_GLASVARIANTE'); filterDependencies('KTU_MM_ZIERLEISTENVAR_O_BS')">
                                </v-select>
                                <div class="text-center image_79a9330b" :style="getRegisteredCharacteristicsValue('KTU_MM_ZIERLEISTENVAR_BS', functionsContext).value.value === 'ZV0' ? 'display:none' : '' ">
                                    <a href="javascript:void(0)" @click="openImageDialogFour = true">
                                        <v-img max-width="75%" class="mx-auto" contain
                                               :src="zierleistenVariantBSImage.resourceLocation ? zierleistenVariantBSImage.resourceLocation : zierleistenVariantGBSImage.resourceLocation" />
                                    </a>
                                </div>
                            </v-col>
                            <v-col cols="6">
                                <div class="subtitle-2 mb-2">{{$t('zierleisteVariantenGegenbandseite')}}</div>
                                <v-select dense outlined return-object :menu-props="{ offsetY: true }"
                                    :items="getCharacteristicAndValues('KTU_MM_ZIERLEISTENVAR_GBS').values"
                                    item-text="description"
                                    :value="getRegisteredCharacteristicsValue('KTU_MM_ZIERLEISTENVAR_GBS', functionsContext).value"
                                    @change="addCharacterisitc($event, getCharacteristicAndValues('KTU_MM_ZIERLEISTENVAR_GBS')); filterDependencies('KTU_MM_FALZGEOMETRIE'); filterDependencies('KTU_MM_ZIERLEISTENVAR_O_GBS');">
                                </v-select>
                                <div class="text-center image_79a9330b" :style="getRegisteredCharacteristicsValue('KTU_MM_ZIERLEISTENVAR_GBS', functionsContext).value.value === 'ZV0' ? 'display:none' : '' ">
                                    <a href="javascript:void(0)" @click="openImageDialogFive = true">
                                        <v-img max-width="75%" class="mx-auto" contain
                                               :src="zierleistenVariantGBSImage.resourceLocation" />
                                    </a>
                                </div>
                            </v-col>
                        </v-row>
                        <v-divider class="mb-4"></v-divider>
                        <v-row>
                            <v-col cols="6">
                                <div class="subtitle-2">{{$t('zierleisteBandseite')}}</div>
                                <v-checkbox class="mt-2"
                                    :disabled="checkStatusOfControl('KTU_MM_ZIERLEISTENVAR_O_BS', 'KTU_MM_ZIERLEISTENVAR_BS', 'ZV0')"
                                    :input-value="getRegisteredCharacteristicsValue('KTU_MM_ZIERLEISTENVAR_O_BS', functionsContext).value.value === 'ZO'"
                                    :label="getCharacteristicAndValues('KTU_MM_ZIERLEISTENVAR_O_BS').description"
                                    @change="checkBoxAdd('KTU_MM_ZIERLEISTENVAR_O_BS')"></v-checkbox>
                            </v-col>
                            <v-col cols="6">
                                <div class="subtitle-2">{{$t('zierleisteGegenbandseite')}}</div>
                                <v-checkbox class="mt-2"
                                    :disabled="checkStatusOfControl('KTU_MM_ZIERLEISTENVAR_O_GBS', 'KTU_MM_ZIERLEISTENVAR_GBS', 'ZV0')"
                                    :input-value="getRegisteredCharacteristicsValue('KTU_MM_ZIERLEISTENVAR_O_GBS', functionsContext).value.value === 'ZO'"
                                    :label="getCharacteristicAndValues('KTU_MM_ZIERLEISTENVAR_O_GBS').description"
                                    @change="checkBoxAdd('KTU_MM_ZIERLEISTENVAR_O_GBS')"></v-checkbox>
                            </v-col>
                        </v-row>
                    </template>
                    <template
                        v-else-if="getSubNavActiveId.mainNavActiveId == 1 && getSubNavActiveId.subNavActiveId == 4">
                        <h3 class="font-weight-regular mb-4 submenu-title">{{$t('lichtausschnitt')}}</h3>
                        <v-row>
                            <v-col cols="6">
                                <div class="subtitle-2 mb-2">{{$t('glasdesign')}}</div>
                                <v-select dense outlined return-object :menu-props="{ offsetY: true }"
                                    :items="getCharacteristicAndValues('KTU_MM_GLASART').values" item-text="description"
                                    :value="getRegisteredCharacteristicsValue('KTU_MM_GLASART', functionsContext).value"
                                    @change="addCharacterisitc($event, getCharacteristicAndValues('KTU_MM_GLASART'));
                                        filterDependencies('KTU_MM_GLASVARIANTE');
                                        filterDependencies('KTU_MM_GLASVARIANTE_O');
                                        filterDependencies('KTU_MM_FUNKTION_BESCHUSS');"></v-select>
                            </v-col>
                            <v-col cols="6">
                                <div class="subtitle-2 mb-2">{{$t('glasVariantenTurblatt')}}</div>
                                <v-select dense outlined return-object :menu-props="{ offsetY: true }"
                                    :items="getCharacteristicAndValues('KTU_MM_GLASVARIANTE').values"
                                    item-text="description"
                                    :value="getRegisteredCharacteristicsValue('KTU_MM_GLASVARIANTE', functionsContext).value"
                                    @change="addCharacterisitc($event, getCharacteristicAndValues('KTU_MM_GLASVARIANTE'));initGlass();">
                                </v-select>
                            </v-col>
                        </v-row>
                        <div>
                            <v-row>
                                <v-col class="col-6">
                                    <div class="text-center image_d0f0d6ef">
                                        <a href="javascript:void(0)" @click="openImageDialogTwo = true">
                                            <v-img max-width="100%" class="mx-auto" contain
                                                   :src="zierleistenVariantBSImage.resourceLocation ? zierleistenVariantBSImage.resourceLocation : zierleistenVariantGBSImage.resourceLocation" />
                                        </a>
                                    </div>
                                </v-col>
                                <v-col class="col-6">
                                    <div class="subtitle-2 mt-5">{{$t('glasInDerOberblende')}}</div>
                                    <v-checkbox class="mt-2"
                                                :disabled="checkStatusOfControl('KTU_MM_GLASVARIANTE_O', 'KTU_MM_GLASART', '0')"
                                                :input-value="getRegisteredCharacteristicsValue('KTU_MM_GLASVARIANTE_O', functionsContext).value.value === 'GO'"
                                                :label="getCharacteristicAndValues('KTU_MM_GLASVARIANTE_O').description"
                                                @change="checkBoxAdd('KTU_MM_GLASVARIANTE_O');initGlass()"></v-checkbox>
                                    <div v-if="hasDoorTopPanel && isTopPanelGlassSelected">
                                        <!-- <v-divider class="mb-2"></v-divider> -->
                                        <!-- <div class="subtitle-2">{{$t('topPanelGlass')}}</div> -->
                                        <v-row>
                                            <v-col cols="6">
                                                <div class="subtitle-2 pb-2">
                                                    {{$t('breite')}}</div>
                                                <v-text-field class="unit-text-field" v-model="topPanelGlassWidth" dense outlined hide-details suffix="mm">
                                                </v-text-field>
                                            </v-col>
                                            
                                            <v-col cols="6">
                                                <div class="subtitle-2 pb-2">
                                                    {{$t('hohe')}}</div>
                                                <v-text-field class="unit-text-field" v-model="topPanelGlassHeight" dense outlined hide-details suffix="mm">
                                                </v-text-field>
                                            </v-col>
                                        </v-row>
                                    </div>
                                    <div v-if="isGlassWingSelected">
                                        <v-divider class="mb-2"></v-divider>
                                        <div class="subtitle-2">{{$t('aktivesBlattglas')}}</div>
                                        <v-row>
                                            <v-col cols="6">
                                                <div class="subtitle-2 pb-2">
                                                    {{$t('breite')}}</div>
                                                <v-text-field class="unit-text-field" v-model="activeLeafGlassWidth" dense outlined hide-details suffix="mm">
                                                </v-text-field>
                                            </v-col>

                                            <v-col cols="6">
                                                <div class="subtitle-2 pb-2">
                                                    {{$t('hohe')}}</div>
                                                <v-text-field class="unit-text-field" v-model="activeLeafGlassHeight" dense outlined hide-details suffix="mm">
                                                </v-text-field>
                                            </v-col>
                                        </v-row>
                                    </div>
                                    <div v-if="isTwoWingDoor && isGlassWingSelected">
                                        <v-divider class="mb-2"></v-divider>
                                        <div class="subtitle-2">
                                            {{$t('stehendesblattglas')}}</div>
                                        <v-row>
                                            <v-col cols="6">
                                                <div class="subtitle-2 pb-2">
                                                    {{$t('breite')}}</div>
                                                <v-text-field class="unit-text-field" v-model="standingLeafGlassWidth" dense outlined hide-details suffix="mm">
                                                </v-text-field>
                                            </v-col>
                                            <v-col cols="6">
                                                <div class="subtitle-2 pb-2">
                                                    {{$t('hoheStarke')}}</div>
                                                <v-text-field class="unit-text-field" v-model="standingLeafGlassHeight" dense outlined hide-details suffix="mm">
                                                </v-text-field>
                                            </v-col>


                                        </v-row>
                                    </div>
                                </v-col>
                            </v-row>
                        </div>
                    </template>
                    <template
                        v-else-if="getSubNavActiveId.mainNavActiveId == 1 && getSubNavActiveId.subNavActiveId == 5">
                        <h3 class="font-weight-regular mb-4 submenu-title">{{$t('schlagleisten')}}</h3>
                        <v-row align="end">
                            <v-col cols="6">
                                <div class="subtitle-2 mb-2">{{$t('schlagleistenSenkrechBandseite')}}</div>
                                <v-select dense outlined return-object :menu-props="{ offsetY: true }"
                                    :items="getCharacteristicAndValues('KTU_MM_SCHLAGL_ANZ_BS').values"
                                    item-text="description"
                                    :value="getRegisteredCharacteristicsValue('KTU_MM_SCHLAGL_ANZ_BS', functionsContext).value"
                                    @change="addCharacterisitc($event, getCharacteristicAndValues('KTU_MM_SCHLAGL_ANZ_BS'))">
                                </v-select>
                            </v-col>
                            <v-col cols="6">
                                <div class="subtitle-2 mb-2">{{$t('schlagleistenSenkrechtGegenbandseite')}}</div>
                                <v-select dense outlined return-object :menu-props="{ offsetY: true }"
                                    :items="getCharacteristicAndValues('KTU_MM_SCHLAGL_ANZ_GBS').values"
                                    item-text="description"
                                    :value="getRegisteredCharacteristicsValue('KTU_MM_SCHLAGL_ANZ_GBS', functionsContext).value"
                                    @change="addCharacterisitc($event, getCharacteristicAndValues('KTU_MM_SCHLAGL_ANZ_GBS'))">
                                </v-select>
                            </v-col>
                            <v-col cols="6">
                                <div class="subtitle-2 mb-2">{{$t('schlagleistewGegenbandseite')}}</div>
                                <v-select dense outlined return-object :menu-props="{ offsetY: true }"
                                    :items="getCharacteristicAndValues('CUST_MM_SCHLAGL_ANZ_W_GBS').values"
                                    item-text="description"
                                    :value="getRegisteredCharacteristicsValue('CUST_MM_SCHLAGL_ANZ_W_GBS', functionsContext).value"
                                    @change="addCharacterisitc($event, getCharacteristicAndValues('KTU_MM_SCHLAGL_ANZ_W_GBS'));
                                    filterDependencies('KTU_MM_SCHLAGL_ANZ_W_GBS');">
                                </v-select>
                            </v-col>
                            <v-col cols="6">
                                <div class="subtitle-2 mb-2">{{$t('schlagleistewBandseite')}}</div>
                                <v-select dense outlined return-object :menu-props="{ offsetY: true }"
                                    :items="getCharacteristicAndValues('CUST_MM_SCHLAGL_ANZ_W_BS').values"
                                    item-text="description"
                                    :value="getRegisteredCharacteristicsValue('CUST_MM_SCHLAGL_ANZ_W_BS', functionsContext).value"
                                    @change="addCharacterisitc($event, getCharacteristicAndValues('KTU_MM_SCHLAGL_ANZ_W_BS'));
                                    filterDependencies('KTU_MM_SCHLAGL_ANZ_W_BS');">
                                </v-select>
                            </v-col>
                        </v-row>
                    </template>
                    <template
                        v-else-if="getSubNavActiveId.mainNavActiveId == 1 && getSubNavActiveId.subNavActiveId == 6">
                        <h3 class="font-weight-regular mb-4 submenu-title">{{$t('schallschutzSonder')}}</h3>
                         <v-row>
                            <v-col md="6" sm="12">
                                <v-select dense outlined return-object :menu-props="{ offsetY: true }"
                                    :items="getCharacteristicAndValues('CUST_MM_SCHALLSCHUTZ_PLUS').values"
                                    item-text="description"
                                    :value="getRegisteredCharacteristicsValue('CUST_MM_SCHALLSCHUTZ_PLUS', functionsContext).value"
                                    @change="handleSchallschutzSonderSelect($event)">
                                </v-select>
                            </v-col>
                         </v-row>
                        
                    </template>
                    <template
                        v-else-if="getSubNavActiveId.mainNavActiveId == 1 && getSubNavActiveId.subNavActiveId == 7">
                        <h3 class="font-weight-regular mb-4 submenu-title">{{$t('beschusshemmung')}}</h3>
                        <v-checkbox class="mt-2" :persistent-hint="true"
                            :disabled="getNrOfValuesByCharacteristic('KTU_MM_FUNKTION_BESCHUSS') < 2"
                            :input-value="getRegisteredCharacteristicsValue('KTU_MM_FUNKTION_BESCHUSS', functionsContext).value.value === 'FB3'"
                            :label="getCharacteristicAndValues('KTU_MM_FUNKTION_BESCHUSS').description"
                            @change="checkBoxAdd('KTU_MM_FUNKTION_BESCHUSS')">
                        </v-checkbox>
                        <p class="menu-description" style="margin-top: -10px;font-size:15px">{{$t('beschusshemmungDescription')}}</p>
                    </template>
<!--                    <template-->
<!--                            v-else-if="getSubNavActiveId.mainNavActiveId == 1 && getSubNavActiveId.subNavActiveId == 8">-->
<!--                        <radio-container :key="8" :characteristic="getCharacteristicAndValues('KTU_MM_FUNKTION_EN1125')" :context="functionsContext" />-->
<!--                    </template>-->
<!--                    <template-->
<!--                            v-else-if="getSubNavActiveId.mainNavActiveId == 1 && getSubNavActiveId.subNavActiveId == 9">-->
<!--                        <radio-container :key="9" :characteristic="getCharacteristicAndValues('KTU_MM_FUNKTION_EN179')" :context="functionsContext" />-->
<!--                    </template>-->
                </simplebar>
            </v-card>
            <div class="bottom-bar pb-6 text-center">
                <v-divider class="py-4"></v-divider>
                <v-btn :disabled="nextSaveBtnDisabled" depressed color="green" dark @click="nextStep();">{{$t('nextStepLabel')}}</v-btn>
            </div>
        </v-col>
        <v-col cols="3" class="py-0">
            <v-card max-height="100%" height="100%" color="grey lighten-3" style="overflow: auto;">
                <v-navigation-drawer width="100%" height="100%" style="padding-top: 70px;" permanent>
                    <div class="d-flex flex-column justify-space-between" style="height: 100%;">
                        <ModelsFound />
                        <div class="pr-1">
                            <v-expansion-panels flat accordion>
                                <RModelSelection />
                            </v-expansion-panels>
                            <v-expansion-panels flat accordion>
                                <RFunctions />
                            </v-expansion-panels>
                        </div>
                        <div class="d-flex flex-column pa-4 right-buttons-holder">
                            <v-row class="px-2">
                                <v-col cols="6" class="px-2" v-if="newConfiguration">
                                    <v-btn outlined color="primary" width="100%" depressed @click="$EventBus.$emit('cancelDialogConfirmation')">
                                        {{ $t('cancelConfiguration') }}
                                    </v-btn>
                                </v-col>
                                <v-col class="px-2" :class="!newConfiguration? 'col-12' : 'col-6'">
                                    <SaveCurrentConfiguration :disabled-save-btn="nextSaveBtnDisabled"/>
                                </v-col>
                            </v-row>
                        </div>
                    </div>
                </v-navigation-drawer>
                <v-dialog v-model="toggleImageDialog" max-width="1000px">
                    <v-img height="100%" max-height="100%"
                        :src="zierleistenVariantBSImage.resourceLocation ? zierleistenVariantBSImage.resourceLocation : zierleistenVariantGBSImage.resourceLocation">
                    </v-img>
                    <v-img height="100%" max-height="100%"
                        :src="falzgeometrieImage.resourceLocation">
                    </v-img>
                    <v-img height="100%" max-height="100%"
                        :src="zierleistenArtImage.resourceLocation">
                    </v-img>
                    <v-img height="100%" max-height="100%"
                        :src="doorOpeningWayImage.resourceLocation">
                    </v-img>
                </v-dialog>
                <v-dialog v-model="openImageDialog" max-width="1000px" width="600">

                    <v-card class="pa-6">
                        <v-card-text>
                            <v-img height="100%" max-height="100%"
                                   :src="getRegisteredCharacteristicsValue('KTU_MM_WANDART_BESTAND', functionsContext).value.resource">
                            </v-img>
                        </v-card-text>

                        <v-divider></v-divider>

                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn
                                    text
                                    @click="openImageDialog = false"
                            >
                                {{$t('closeLabel')}}
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
                <v-dialog v-model="openImageDialogTwo" max-width="1000px" width="600">

                    <v-card>
                        <v-card-text>
                            <v-img height="100%" max-height="100%"
                                   :src="zierleistenVariantBSImage.resourceLocation ? zierleistenVariantBSImage.resourceLocation : zierleistenVariantGBSImage.resourceLocation">
                            </v-img>
                        </v-card-text>

                        <v-divider></v-divider>

                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn
                                    text
                                    @click="openImageDialogTwo = false"
                            >
                                {{$t('closeLabel')}}
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
                <v-dialog v-model="openImageDialogThree" max-width="1000px" width="800">

                    <v-card>
                        <v-card-text>
                            <v-img height="100%" max-height="100%"
                                   :src="doorOpeningWayImage.resourceLocation">
                            </v-img>
                        </v-card-text>

                        <v-divider></v-divider>

                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn
                                    text
                                    @click="openImageDialogThree = false"
                            >
                                {{$t('closeLabel')}}
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
                <v-dialog v-model="openImageDialogFour" max-width="1000px" width="600">

                    <v-card>
                        <v-card-text>
                            <v-img height="100%" max-height="100%"
                                   :src="zierleistenVariantBSImage.resourceLocation ? zierleistenVariantBSImage.resourceLocation: zierleistenVariantGBSImage.resourceLocation">
                            </v-img>
                        </v-card-text>

                        <v-divider></v-divider>

                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn
                                    text
                                    @click="openImageDialogFour = false"
                            >
                                {{$t('closeLabel')}}
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
                <v-dialog v-model="openImageDialogFive" max-width="1000px" width="600">

                    <v-card>
                        <v-card-text>
                            <v-img height="100%" max-height="100%"
                                   :src="zierleistenVariantGBSImage.resourceLocation">
                            </v-img>
                        </v-card-text>

                        <v-divider></v-divider>

                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn
                                    text
                                    @click="openImageDialogFive = false"
                            >
                                {{$t('closeLabel')}}
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
                <v-dialog v-model="openImageDialogSix" max-width="1000px" width="1000">

                    <v-card>
                        <v-card-text>
                            <v-img height="100%" max-height="100%"
                                   :src="zierleistenArtImage.resourceLocation">
                            </v-img>
                        </v-card-text>

                        <v-divider></v-divider>

                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn
                                    text
                                    @click="openImageDialogSix = false"
                            >
                                {{$t('closeLabel')}}
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
            </v-card>
        </v-col>
    </v-row>
    <!-- <div class="content-wrapper" id="functions">
        <div class="wrapper-mask show" v-if="showModal"></div>
        <div class="row no-gutters content-row" v-if="!showModal">
            <div class="col-3">
                <div class="column-wrap d-flex flex-column">
                    <h3 class="title nav-title">Funktionsauswahl</h3>
                    <div class="inner-wrap d-flex" data-simplebar>
                        <div class="nav flex-column nav-pills main-navigation text-left" id="v-pills-tab" role="tablist" aria-orientation="vertical">
                            <a v-bind:class="{ 'nav-link': true, 'active': active == 1, 'success': getFuncItem(1).completed() }" @click.prevent="settingsNavigation(1)">Auswahl Aufgehrichtung</a>
                            <a v-bind:class="{ 'nav-link': true, 'active': active == 2, 'success': getFuncItem(2).completed() }" @click.prevent="settingsNavigation(2)">Auswahl Mauerwerk</a>
                            <a v-bind:class="{ 'nav-link': true, 'active': active == 6, 'success': getFuncItem(3).completed() }" @click.prevent="settingsNavigation(6)">Zusatzdichtung (automatisch ab 39 dB und wenn Rauchschutz ausgewählt)</a>
                            <a v-bind:class="{ 'nav-link': true, 'active': active == 8, 'success': getFuncItem(4).completed() }" @click.prevent="settingsNavigation(8)">Zierleisten</a>
                            <a v-bind:class="{ 'nav-link': true, 'active': active == 7, 'success': getFuncItem(5).completed() }" @click.prevent="settingsNavigation(7)">Lichtausschnitt</a>
                            <a v-bind:class="{ 'nav-link': true, 'active': active == 4, 'success': getFuncItem(7).completed() }" @click.prevent="settingsNavigation(4)">Schlagleisten</a>
                            <a v-bind:class="{ 'nav-link': true, 'active': active == 3, 'success': getFuncItem(8).completed() }" @click.prevent="settingsNavigation(3)">Schallschutz Sonder</a>
                            <a v-bind:class="{ 'nav-link': true, 'active': active == 9, 'success': getFuncItem(9).completed() }" @click.prevent="settingsNavigation(9)">Beschusshemmung</a>
                        </div>
                    </div>
                     <div class="image-container left-image">
                        <div class="text-center">
                            <img style="max-width: 50%;" :src="zierleistenVariantBSImage.resourceLocation" alt="">
                        </div>
                    </div>
                    <div class="image-container left-image">
                        <div class="text-center">
                            <img style="max-width: 50%;" :src="falzgeometrieImage.resourceLocation" alt="">
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-6 purple-background-after">
                <div class="column-wrap middle-col  d-flex flex-column">
                    <div class="inner-wrap d-flex" data-simplebar id="innerWrapper">
                        <div class="scroll-wrap">
                            <div v-bind:class="{'inputs-group': true, 'active': showSettingsContent == 1}">
                                <h1 class="title">{{getCharacteristicAndValues("KTU_MM_AUFGEHRICHTUNG").description}}</h1>
                                <div class="full-dropdown">
                                    <div class="dropdown">
                                    <button class="btn btn-secondary dropdown-toggle dropdown-button" type="button"
                                        id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true"
                                        aria-expanded="false">{{ getRegisteredCharacteristicsValue('KTU_MM_AUFGEHRICHTUNG', functionsContext).value.description }}
                                        <span></span>
                                    </button>
                                    <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                        <div style="max-height: 500px; overflow-y: auto;">  
                                            <a v-for="(valueDefinition, index) in getCharacteristicAndValues('KTU_MM_AUFGEHRICHTUNG').values" :key="index" @click.prevent="addCharacterisitc(getCharacteristicAndValues('KTU_MM_AUFGEHRICHTUNG'), valueDefinition);" class="dropdown-item" href="#">{{ valueDefinition.description }}</a>
                                        </div>
                                    </div>
                                    </div>
                                </div>
                                <div class="image-container">
                                    <div class="row">
                                        <div class="col-12">
                                            <div class="text-center">
                                                <img style="max-width: 50%;" :src="doorOpeningWayImage.resourceLocation" alt="">                                                
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div v-bind:class="{'inputs-group': true, 'active': showSettingsContent == 2}">
                                <h1 class="title">Auswahl Mauerwerk</h1>
                                <div class="full-dropdown">
                                    <div class="dropdown">
                                        <button class="btn btn-secondary dropdown-toggle dropdown-button" type="button"
                                            id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true"
                                            aria-expanded="false"> {{ getRegisteredCharacteristicsValue('KTU_MM_WANDART_BESTAND', functionsContext).value.description }}
                                            <span></span>
                                        </button>
                                        <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                              
                                                <div style="max-height: 500px; overflow-y: auto;">
                                                    <a v-for="(valueDefinition, index) in getCharacteristicAndValues('KTU_MM_WANDART_BESTAND').values" :key="index" @click.prevent="addCharacterisitc(getCharacteristicAndValues('KTU_MM_WANDART_BESTAND'), valueDefinition)" class="dropdown-item" href="#">{{ valueDefinition.description }}</a>
                                                </div>   
                                            
                                        </div>
                                    </div>
                                </div>
                                <div class="input-group disabled">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text" id="inputGroup-sizing-default">Mindestbestandsstarke</span>
                                    </div>
                                    <input type="text" class="form-control" aria-label="Default" disabled value="100" aria-describedby="inputGroup-sizing-default">
                                    <span class="post">mm</span>
                                </div>
                                <div class="input-group">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text" id="inputGroup-sizing-default">Vorhandene Bestandsstärke eingeben</span>
                                    </div>
                                    <input type="text" v-model="getRegisteredCharacteristicsValue('KTU_MM_WANDDICKE', functionsContext).value.value" class="form-control" aria-label="Default" aria-describedby="inputGroup-sizing-default" 
                                    @change="valueAddCharacteristic(getCharacteristicAndValues('KTU_MM_WANDDICKE'), getRegisteredCharacteristicsValue('KTU_MM_WANDDICKE', functionsContext).value.value)">
                                    <span class="post">mm</span>
                                </div>
                                <div class="image-container">
                                    <div class="row">
                                        <div class="col-12">
                                            <div class="text-center">                                                
                                                <img style="max-width: 50%;" :src="getRegisteredCharacteristicsValue('KTU_MM_WANDART_BESTAND', functionsContext).value.resource" alt="">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div v-bind:class="{'inputs-group': true, 'active': showSettingsContent == 3}">
                                <h1 class="title">Schallschutz Sonder</h1>
                                <div class="full-dropdown">
                                    <div class="dropdown">
                                        <button class="btn btn-secondary dropdown-toggle dropdown-button" type="button"
                                            id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                            {{ getRegisteredCharacteristicsValue('KTU_MM_SCHALLSCHUTZ_PLUS', functionsContext).value.description }}
                                            <span></span>
                                        </button>
                                        <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                            
                                                <div style="max-height: 500px; overflow-y: auto;">
                                                    <a class="dropdown-item" href="#">Select an option</a>
                                                    <a v-for="(valueDefinition, index) in getCharacteristicAndValues('KTU_MM_SCHALLSCHUTZ_PLUS').values" :key="index"
                                                        @click.prevent="addCharacterisitc(getCharacteristicAndValues('KTU_MM_SCHALLSCHUTZ_PLUS'), valueDefinition)" class="dropdown-item" href="#">
                                                            {{ valueDefinition.description }}
                                                    </a>
                                                </div>
                                            
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div v-bind:class="{'inputs-group': true, 'active': showSettingsContent == 4}">
                                <h1 class="title">Schlagleisten</h1>
                                <div class="input-group">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text" id="inputGroup-sizing-default">Schlagleisten senkrecht Bandseite optional</span>
                                    </div>
                                    <div class="dropdown">
                                        <button class="btn btn-secondary dropdown-toggle" type="button" id="dropdownMenuButton"
                                            data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"> {{ getRegisteredCharacteristicsValue('KTU_MM_SCHLAGL_ANZ_BS', functionsContext).value.description }}
                                            <span></span>
                                        </button>
                                        <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">  
                                            <div class="simplebar" data-simplebar>
                                                <div>                                          
                                                    <a v-for="(valueDefinition, index) in getCharacteristicAndValues('KTU_MM_SCHLAGL_ANZ_BS').values" :key="index"
                                                        @click.prevent="addCharacterisitc(getCharacteristicAndValues('KTU_MM_SCHLAGL_ANZ_BS'), valueDefinition)" 
                                                        class="dropdown-item" href="#">{{ valueDefinition.description }}
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="input-group">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text" id="inputGroup-sizing-default">Schlagleisten senkrecht Gegenbandseite vorgegeben</span>
                                    </div>
                                    <div class="dropdown">
                                        <button class="btn btn-secondary dropdown-toggle" type="button" id="dropdownMenuButton"
                                            data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"> {{ getRegisteredCharacteristicsValue('KTU_MM_SCHLAGL_ANZ_GBS', functionsContext).value.description }}
                                            <span></span>
                                        </button>
                                        <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                            <div class="simplebar" data-simplebar>
                                                <div>
                                                    <a v-for="(valueDefinition, index) in getCharacteristicAndValues('KTU_MM_SCHLAGL_ANZ_GBS').values" :key="index"
                                                    @click.prevent="addCharacterisitc(getCharacteristicAndValues('KTU_MM_SCHLAGL_ANZ_GBS'), valueDefinition)"
                                                    class="dropdown-item" href="#">{{ valueDefinition.description }}</a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="input-group">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text" id="inputGroup-sizing-default">Schlagleiste waagrecht Gegenbandseite</span>
                                    </div>
                                    <div class="dropdown">
                                        <button class="btn btn-secondary dropdown-toggle" type="button" id="dropdownMenuButton"
                                            data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"> {{ getRegisteredCharacteristicsValue('KTU_MM_SCHLAGL_ANZ_W_GBS', functionsContext).value.description }}
                                            <span></span>
                                        </button>
                                        <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                            <div class="simplebar" data-simplebar>
                                                <div>
                                                    <a v-for="(valueDefinition, index) in getCharacteristicAndValues('KTU_MM_SCHLAGL_ANZ_W_GBS').values" :key="index" 
                                                    @click.prevent="addCharacterisitc(getCharacteristicAndValues('KTU_MM_SCHLAGL_ANZ_W_GBS'), valueDefinition)"
                                                    class="dropdown-item" href="#">{{ valueDefinition.description }}</a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="input-group">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text" id="inputGroup-sizing-default">Schlagleiste waagrecht Bandseite optional</span>
                                    </div>
                                    <div class="dropdown">
                                        <button class="btn btn-secondary dropdown-toggle" type="button" id="dropdownMenuButton"
                                            data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"> {{ getRegisteredCharacteristicsValue('KTU_MM_SCHLAGL_ANZ_W_BS', functionsContext).value.description }}
                                            <span></span>
                                        </button>
                                        <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                            <div class="simplebar" data-simplebar>
                                                <div>
                                                    <a v-for="(valueDefinition, index) in getCharacteristicAndValues('KTU_MM_SCHLAGL_ANZ_W_BS').values" :key="index" 
                                                    @click.prevent="addCharacterisitc(getCharacteristicAndValues('KTU_MM_SCHLAGL_ANZ_W_BS'), valueDefinition)"
                                                    class="dropdown-item" href="#">{{ valueDefinition.description }}</a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div v-bind:class="{'inputs-group': true, 'active': showSettingsContent == 6}">
                                <h1 class="title">Zusatzdichtung (automatisch ab 39 dB und wenn Rauchschutz ausgewählt)</h1>                                
                                <div class="btn-group btn-group-toggle c-btn-group-toggle" data-toggle="buttons">
                                    
                                    <label @click="checkBoxAdd('KTU_MM_RH_DICHTUNG')" class="btn btn-secondary" 
                                    :class="{'active': getRegisteredCharacteristicsValue('KTU_MM_RH_DICHTUNG', functionsContext).value.value === 'JA', 
                                             'c-disabled': getNrOfValuesByCharacteristic('KTU_MM_RH_DICHTUNG') < 2 }">
                                        <div class="check-btn">
                                            <span></span>
                                        </div>
                                        <input type="checkbox" autocomplete="off"> {{ getCharacteristicAndValues('KTU_MM_RH_DICHTUNG').description }}
                                    </label>
                                    
                                </div>
                            </div>

                            <div v-bind:class="{'inputs-group': true, 'active': showSettingsContent == 7}">
                                <h1 class="title">Lichtausschnitt</h1>
                                <label class="input-label">Glasdesign</label>
                                <div class="full-dropdown">
                                    <div class="dropdown">
                                        <button class="btn btn-secondary dropdown-toggle dropdown-button" type="button"
                                            id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true"
                                            aria-expanded="false">{{ getRegisteredCharacteristicsValue('KTU_MM_GLASART', functionsContext).value.description }}<span></span>
                                        </button>
                                        <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                            
                                                <div style="max-height: 500px; overflow-y: auto;">
                                                    <a v-for="(valueDefinition, index) in getCharacteristicAndValues('KTU_MM_GLASART').values" :key="index"
                                                    @click.prevent="addCharacterisitc(getCharacteristicAndValues('KTU_MM_GLASART'), valueDefinition);
                                                    filterDependencies('KTU_MM_GLASVARIANTE');
                                                    filterDependencies('KTU_MM_GLASVARIANTE_O');
                                                    filterDependencies('KTU_MM_FUNKTION_BESCHUSS')" 
                                                    class="dropdown-item" href="#">{{ valueDefinition.description }}</a>
                                                </div>
                                            
                                        </div>
                                    </div>
                                </div>
                                <label class="input-label">Glas Varianten Türblatt</label>
                                <div class="full-dropdown">
                                    <div class="dropdown">
                                        <button class="btn btn-secondary dropdown-toggle dropdown-button" type="button"
                                            id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true"
                                            aria-expanded="false">{{ getRegisteredCharacteristicsValue('KTU_MM_GLASVARIANTE', functionsContext).value.description }}<span></span>
                                        </button>
                                        <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                            
                                            
                                                <div style="max-height: 500px; overflow-y: auto;">
                                                    <a v-for="(valueDefinition, index) in getCharacteristicAndValues('KTU_MM_GLASVARIANTE').values" :key="index" 
                                                    @click.prevent="addCharacterisitc(getCharacteristicAndValues('KTU_MM_GLASVARIANTE'), valueDefinition);" 
                                                    class="dropdown-item" href="#">{{ valueDefinition.description }}</a>
                                                </div>
                                            
                                        </div>
                                    </div>
                                </div>
                                <div class="image-container">
                                    <div class="text-center">
                                        <img style="max-width: 35%;" :src="zierleistenVariantBSImage.resourceLocation" alt="">
                                    </div>
                                </div>
                                
                                <label class="input-label">Glas in der Oberblende</label>
                                <div class="btn-group btn-group-toggle c-btn-group-toggle" data-toggle="buttons">
                                    <label @click="checkBoxAdd('KTU_MM_GLASVARIANTE_O')" class="btn btn-secondary" 
                                    :class="{'active': getRegisteredCharacteristicsValue('KTU_MM_GLASVARIANTE_O', functionsContext).value.value === 'GO',
                                             'c-disabled': checkStatusOfControl('KTU_MM_GLASVARIANTE_O', 'KTU_MM_GLASART', '0') }">
                                        <div class="check-btn">
                                            <span></span>
                                        </div>

                                        <input type="checkbox" autocomplete="off"> {{ getCharacteristicAndValues('KTU_MM_GLASVARIANTE_O').description }}
                                    </label>                                                                                   
                                </div>
                            </div>
                            <div v-bind:class="{'inputs-group': true, 'active': showSettingsContent == 8}">
                                <h1 class="title">Zierleiste</h1>
                                <div class="group-wrapper">
                                    <label class="input-label">Zierleistenart</label>
                                    <div class="full-dropdown">
                                        <div class="dropdown">
                                            <button class="btn btn-secondary dropdown-toggle dropdown-button" type="button"
                                                id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true"
                                                aria-expanded="false">{{ getRegisteredCharacteristicsValue('KTU_MM_ZIERLEISTENART', functionsContext).value.description }}<span></span>
                                            </button>
                                            <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                                
                                                    <div style="max-height: 500px; overflow-y: auto;">
                                                        <a v-for="(valueDefinition, index) in getCharacteristicAndValues('KTU_MM_ZIERLEISTENART').values" :key="index"
                                                                @click.prevent="addCharacterisitc(getCharacteristicAndValues('KTU_MM_ZIERLEISTENART'), valueDefinition);                                                        
                                                                filterDependencies('KTU_MM_ZIERLEISTENVAR_BS');
                                                                filterDependencies('KTU_MM_ZIERLEISTENVAR_GBS');"
                                                                class="dropdown-item" href="#">{{ valueDefinition.description }}
                                                        </a>
                                                    </div>
                                                
                                            </div>
                                        </div>
                                    </div>
                                    <div class="image-container">
                                        <div class="text-center">
                                            
                                            <img style="max-width: 70%;" :src="zierleistenArtImage.resourceLocation" alt="">                                            
                                        </div>
                                    </div>
                                </div>
                                <hr/>
                                <div class="group-wrapper">
                                    <div class="row">
                                        <div class="col-6">
                                            <label class="input-label">Zierleiste Varianten Bandseite</label>
                                            <div class="full-dropdown">
                                                <div class="dropdown">
                                                    <button class="btn btn-secondary dropdown-toggle dropdown-button"
                                                        type="button" id="dropdownMenuButton" data-toggle="dropdown"
                                                        aria-haspopup="true" aria-expanded="false">{{ getRegisteredCharacteristicsValue('KTU_MM_ZIERLEISTENVAR_BS', functionsContext).value.description }}<span></span>
                                                    </button>
                                                    <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                                        
                                                            <div style="max-height: 500px; overflow-y: auto;">
                                                                <a v-for="(valueDefinition, index) in getCharacteristicAndValues('KTU_MM_ZIERLEISTENVAR_BS').values" :key="index"
                                                                    @click.prevent="addCharacterisitc(getCharacteristicAndValues('KTU_MM_ZIERLEISTENVAR_BS'), valueDefinition);
                                                                    filterDependencies('KTU_MM_GLASVARIANTE');filterDependencies('KTU_MM_ZIERLEISTENVAR_O_BS');"
                                                                    class="dropdown-item" href="#">{{ valueDefinition.description }}
                                                                </a>
                                                            </div>
                                                        
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="image-container">
                                                <div class="text-center">
                                                    <img style="max-width: 70%;" :src="zierleistenVariantBSImage.resourceLocation" alt="">
                                                    
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-6">
                                            <label class="input-label">Zierleiste Varianten Gegenbandseite</label>
                                            <div class="full-dropdown">
                                                <div class="dropdown">
                                                    <button class="btn btn-secondary dropdown-toggle dropdown-button"
                                                        type="button" id="dropdownMenuButton" data-toggle="dropdown"
                                                        aria-haspopup="true" aria-expanded="false">{{ getRegisteredCharacteristicsValue('KTU_MM_ZIERLEISTENVAR_GBS', functionsContext).value.description }}<span></span>
                                                    </button>
                                                    <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                                        
                                                            <div style="max-height: 500px; overflow-y: auto;">
                                                                <a v-for="(valueDefinition, index) in getCharacteristicAndValues('KTU_MM_ZIERLEISTENVAR_GBS').values" :key="index"
                                                                    @click.prevent="addCharacterisitc(getCharacteristicAndValues('KTU_MM_ZIERLEISTENVAR_GBS'), valueDefinition);
                                                                    filterDependencies('KTU_MM_FALZGEOMETRIE');filterDependencies('KTU_MM_ZIERLEISTENVAR_O_GBS');"
                                                                    class="dropdown-item" href="#">{{ valueDefinition.description }}
                                                                </a>
                                                            </div>
                                                        
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="image-container">
                                                <div class="text-center">
                                                    <img style="max-width: 70%;" :src="zierleistenVariantGBSImage.resourceLocation" alt="">
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <hr/>
                                <div class="group-wrapper">
                                    <div class="row">
                                        <div class="col-6">
                                            <label class="input-label">Zierleiste Bandseite</label>
                                            <div class="btn-group btn-group-toggle c-btn-group-toggle" data-toggle="buttons">
                                                <label @click="checkBoxAdd('KTU_MM_ZIERLEISTENVAR_O_BS')" class="btn btn-secondary" 
                                                :class="{'active': getRegisteredCharacteristicsValue('KTU_MM_ZIERLEISTENVAR_O_BS', functionsContext).value.value === 'ZO',
                                                         'c-disabled': checkStatusOfControl('KTU_MM_ZIERLEISTENVAR_O_BS', 'KTU_MM_ZIERLEISTENVAR_BS', 'ZV0') }">
                                                    <div class="check-btn">
                                                        <span></span>
                                                    </div>
                                                    <input type="checkbox" autocomplete="off"> {{ getCharacteristicAndValues('KTU_MM_ZIERLEISTENVAR_O_BS').description }}
                                                </label>                                          
                                            </div>
                                        </div>
                                        <div class="col-6">
                                            <label class="input-label">Zierleiste Gegenbandseite</label>
                                            <div class="btn-group btn-group-toggle c-btn-group-toggle" data-toggle="buttons">
                                                <label @click="checkBoxAdd('KTU_MM_ZIERLEISTENVAR_O_GBS')" class="btn btn-secondary" 
                                                :class="{'active': getRegisteredCharacteristicsValue('KTU_MM_ZIERLEISTENVAR_O_GBS', functionsContext).value.value === 'ZO',
                                                         'c-disabled': checkStatusOfControl('KTU_MM_ZIERLEISTENVAR_O_GBS', 'KTU_MM_ZIERLEISTENVAR_GBS', 'ZV0') }">
                                                    <div class="check-btn">
                                                        <span></span>
                                                    </div>
                                                    <input type="checkbox" autocomplete="off"> {{ getCharacteristicAndValues('KTU_MM_ZIERLEISTENVAR_O_GBS').description }}                                                    
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                </div>                               
                            </div>
                            <div v-bind:class="{'inputs-group': true, 'active': showSettingsContent == 9}">
                                <h1 class="title">Beschusshemmung</h1>                                
                                <div class="btn-group btn-group-toggle c-btn-group-toggle" data-toggle="buttons">
                                    <label @click="checkBoxAdd('KTU_MM_FUNKTION_BESCHUSS')" class="btn btn-secondary" 
                                    :class="{'active': getRegisteredCharacteristicsValue('KTU_MM_FUNKTION_BESCHUSS', functionsContext).value.value === 'FB3',
                                            'c-disabled': getNrOfValuesByCharacteristic('KTU_MM_FUNKTION_BESCHUSS') < 2 }">
                                        <div class="check-btn">
                                            <span></span>
                                        </div>
                                        <input type="checkbox" autocomplete="off"> {{ getCharacteristicAndValues('KTU_MM_FUNKTION_BESCHUSS').description }}
                                    </label>                                    
                                </div>
                                <label class="label-desc top-label">Hinweis EN179 / EN1125: Bei 2-flügeliger Tür nur am Gehflügel möglich!</label>
                            </div>

                            
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-3">
                <div class="column-wrap side-col d-flex flex-column">
                    <div class="side-wrap d-flex flex-column">
                        <div class="info-wrap">
                            <ModelsFound />
                            <div class="inner-wrap d-flex right-part-inner-wrap" data-simplebar>
                                <RModelSelection></RModelSelection>
                                <div class="accordion" id="accordionExample">
                                    <div class="card">
                                        <div class="card-header" id="headingOne">
                                            <h5 class="mb-0">
                                                <button class="btn btn-link collapsed" type="button" data-toggle="collapse"
                                                    data-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                                                    Funktionsauswahl
                                                </button>
                                            </h5>
                                        </div>

                                        <div id="collapseOne" class="collapse" aria-labelledby="headingOne"
                                            data-parent="#accordionExample">
                                            <RFunctions></RFunctions>
                                        </div>
                                    </div>
                                </div>
                            </div>
                           <v-app>
                                    <div class="d-flex flex-column pa-4">
                                        <v-btn depressed color="green" dark @click="nextStep();">Weiter</v-btn>
                                        <v-row class="px-2">
                                            <v-col cols="6" class="px-2">
                                                <v-btn width="100%" depressed @click="$EventBus.$emit('cancelDialogConfirmation')">Cancel</v-btn> 
                                            </v-col>
                                            <v-col cols="6" class="px-2">
                                                <SaveCurrentConfiguration />   
                                            </v-col>
                                        </v-row>
                                    </div>
                                </v-app>
                        </div>                        
                    </div>                    
                </div>
            </div>
        </div>
        <div class="row no-gutters modal-row show" v-if="showModal">
            <div class="col-12">
                <div class="zoom-modal d-flex">
                    <a @click.prevent="toggleModal(false)" class="close-btn">
                        <img src="./../../assets/images/close.svg" alt="">
                    </a>
                    <img src="./../../assets/images/sample.svg" alt="" class="align-middle">
                </div>
            </div>
        </div>
    </div> -->
</template>
<script>
    import * as $ from 'jquery';
    import Vue from 'vue';
    import {
        Characteristic,
        ValueDefinition,
        MapCharacteristicAndValue,
        DependenciesFilter
    } from '../../configurator/types';
    import {
        mapActions
    } from 'vuex';
    import {
        mapGetters
    } from 'vuex';

    import resourcesService from '../../services/Configurator/ResourcesService';
    import ModelsFound from './components/ModelsFound';
    import {
        DoorConfiguration
    } from '../../configurator/DoorConfiguration';
    import {
        MainNavigationFilter
    } from '../../configurator/MainNavigation';
    import MSRadioContainer from './components/MSRadionContainer';
    import RModelSelection from './components/RModelSelection.vue';
    import RFunctions from './components/RFunctions.vue';
    import SaveCurrentConfiguration from './components/SaveCurrentConfiguration';
    import {
        forEach
    } from 'typescript-collections/dist/lib/arrays';
    import simplebar from 'simplebar-vue';
    import 'simplebar/dist/simplebar.min.css';
    import {parseToGermanFloat, parseFloatFromGermanFloat} from '../../services/ParserService';

    export default Vue.extend({
        name: 'Functions',
        components: {
            simplebar,
            'radio-container': MSRadioContainer,
            RModelSelection,
            RFunctions,
            ModelsFound,
            SaveCurrentConfiguration,
        },
        data() {
            return {
                parseToGermanFloat: parseToGermanFloat,
                parseFloatFromGermanFloat: parseFloatFromGermanFloat,
                openImageDialog: false,
                openImageDialogTwo: false,
                openImageDialogThree: false,
                openImageDialogFour: false,
                openImageDialogFive: false,
                openImageDialogSix: false,
                showResources: true,
                toggleResources: false,
                toggleImageDialog: false,
                showModal: false,
                showSettingsContent: 0,
                active: 0,
                windowMainNavId: 2,
                number: 0,
                bodyCalcHeight: 0,
                KTU_MM_WANDDICKE_RULES: {
                    miniumValue(value,min) {
                        return (value || "") >= min || `Value must be at least ${min}`;
                    },
                },
                functionsContext: DoorConfiguration.Functions,
                KTU_MM_WANDDICKE_Value: 0,
                doorOpeningWayImage: {
                    resourceLocation: require('../../../public/img/placeholder.jpg'),
                },
                falzgeometrieImage: {
                    resourceLocation: require('../../../public/img/placeholder.jpg'),
                },
                zierleistenArtImage: {
                    resourceLocation: require('../../../public/img/placeholder.jpg'),
                },
                zierleistenVariantBSImage: {
                    resourceLocation: require('../../../public/img/placeholder.jpg'),
                },
                zierleistenVariantGBSImage: {
                    resourceLocation: require('../../../public/img/placeholder.jpg'),
                },
                wanddickeValue : '',
                activeLeafGlassHeightValue: 0,
                activeLeafGlassWidthValue: 0,
                standingLeafGlassHeightValue: 0,
                standingLeafGlassWidthValue: 0,
                topPanelGlassHeightValue: 0,
                topPanelGlassWidthValue: 0,
                nextSaveBtnDisabled: false
            }
        },
        computed: {
            ...mapGetters('configuratorModule', ['getSubNavActiveId', 'getCurrentDoorConfiguration',
                'getMainNav', 'getCurrentDoorModel',
                'getContextRegisteredCharacteristics', 'getRegisteredCharacteristicsValue', 'getFuncItem',
                'getFuncItems'
            ]),
            ...mapGetters('functionsModule', ['getFunctionsCharacteristics', 'getCharacteristicAndValues',
                'getNrOfValuesByCharacteristic',
            ]),
            ...mapGetters('modelSelectionModule', ['getNavigationItems','getCharacteristic']), // to be tested
            newConfiguration: function(){
                if(this.$store.state.configuratorModule.productId == 0){
                    return true
                }
                else{
                    return false
                }
            },
            numberOfShownImages(){
                let number = 0
                if (this.zierleistenVariantBSImage.resourceLocation !== '' && !this.zierleistenVariantBSImage.resourceLocation.includes('placeholder'))
                    number += 1
				else if(this.zierleistenVariantGBSImage.resourceLocation !== '' && !this.zierleistenVariantGBSImage.resourceLocation.includes('placeholder'))
					number += 1

                if (this.falzgeometrieImage.resourceLocation !== '' && !this.falzgeometrieImage.resourceLocation.includes('placeholder'))
                    number += 1

                if (this.zierleistenArtImage.resourceLocation !== '' && !this.zierleistenArtImage.resourceLocation.includes('placeholder'))
                    number += 1

                if (this.doorOpeningWayImage.resourceLocation !== '' && !this.doorOpeningWayImage.resourceLocation.includes('placeholder'))
                    number += 1

                return number
            },
            wanddicke : {
                get: function(){
                    return this.parseToGermanFloat(this.getRegisteredCharacteristicsValue('KTU_MM_WANDDICKE', this.functionsContext).value.value);
                },
                set: function(newValue){
                    this.valueAddCharacteristic(this.parseFloatFromGermanFloat(newValue), this.getCharacteristicAndValues('KTU_MM_WANDDICKE'))
                }
            },
            activeLeafGlassHeight: {
                // getter
                get: function () {
                    this.activeLeafGlassHeightValue = this.getRegisteredCharacteristicsValue('KTU_MM_GLAS_G_HOEHE', this.functionsContext).value.value;
                    return this.activeLeafGlassHeightValue;
                },
                // setter
                set: function (newValue) {
                    this.valueAddCharacteristic(newValue, this.getCharacteristicAndValues('KTU_MM_GLAS_G_HOEHE'))
                    this.activeLeafGlassHeightValue = newValue;
                }
            },
            activeLeafGlassWidth: {
                // getter
                get: function () {
                    this.activeLeafGlassWidthValue = this.getRegisteredCharacteristicsValue('KTU_MM_GLAS_G_BREITE', this.functionsContext).value.value;
                    return this.activeLeafGlassWidthValue;
                },
                // setter
                set: function (newValue) {
                    this.valueAddCharacteristic(newValue, this.getCharacteristicAndValues('KTU_MM_GLAS_G_BREITE'))
                    this.activeLeafGlassWidthValue = newValue;
                }
            },
            standingLeafGlassHeight: {
                // getter
                get: function () {
                    this.standingLeafGlassHeightValue = this.getRegisteredCharacteristicsValue('KTU_MM_GLAS_S_HOEHE', this.functionsContext).value.value;
                    return this.standingLeafGlassHeightValue;
                },
                // setter
                set: function (newValue) {
                    this.valueAddCharacteristic(newValue, this.getCharacteristicAndValues('KTU_MM_GLAS_S_HOEHE'))
                    this.standingLeafGlassHeightValue = newValue;
                }
            },
            standingLeafGlassWidth: {
                // getter
                get: function () {
                    this.standingLeafGlassWidthValue = this.getRegisteredCharacteristicsValue('KTU_MM_GLAS_S_BREITE', this.functionsContext).value.value;
                    return this.standingLeafGlassWidthValue;
                },
                // setter
                set: function (newValue) {
                    this.valueAddCharacteristic(newValue, this.getCharacteristicAndValues('KTU_MM_GLAS_S_BREITE'))
                    this.standingLeafGlassWidthValue = newValue;
                }
            },
            topPanelGlassHeight: {
                // getter
                get: function () {
                    this.topPanelGlassHeightValue = this.getRegisteredCharacteristicsValue('KTU_MM_GLAS_O_HOEHE', this.functionsContext).value.value;
                    return this.topPanelGlassHeightValue;
                },
                // setter
                set: function (newValue) {
                    this.valueAddCharacteristic(newValue, this.getCharacteristicAndValues('KTU_MM_GLAS_O_HOEHE'))
                    this.topPanelGlassHeightValue = newValue;
                }
            },
            topPanelGlassWidth: {
                // getter
                get: function () {
                    this.topPanelGlassWidthValue = this.getRegisteredCharacteristicsValue('KTU_MM_GLAS_O_BREITE', this.functionsContext).value.value;
                    return this.topPanelGlassWidthValue;
                },
                // setter
                set: function (newValue) {
                    this.valueAddCharacteristic(newValue, this.getCharacteristicAndValues('KTU_MM_GLAS_O_BREITE'))
                    this.topPanelGlassWidthValue = newValue;
                }
            },
            isTwoWingDoor: function() {
                let getCharValue = this.getRegisteredCharacteristicsValue("KTU_MM_OEFFNUNGSART", DoorConfiguration.ModelSelection).value.value === 'D2';
                if(!getCharValue) {
                    this.standingLeafGlassHeight = 0;
                    this.standingLeafGlassWidth = 0;
                }
                return getCharValue;
            },
            hasDoorTopPanel: function() {
                return this.getRegisteredCharacteristicsValue("KTU_MM_KOMBI_ST_OL", DoorConfiguration.ModelSelection).value.value.includes('O');
            },
            isTopPanelGlassSelected: function() {
                return !(this.getRegisteredCharacteristicsValue("KTU_MM_GLASVARIANTE_O", this.functionsContext).value.value === '0');
            },
            isGlassWingSelected: function() {
                return !(this.getRegisteredCharacteristicsValue("KTU_MM_GLASVARIANTE", this.functionsContext).value.value === '0');
            },
            zierleistenArtChanged: function () {
                const _this = this;
                return _this.getRegisteredCharacteristicsValue("KTU_MM_ZIERLEISTENART", this
                    .functionsContext).value.value;
            },
            zierleistenVariantBSChanged: function () {
                const _this = this;
                return _this.getRegisteredCharacteristicsValue("KTU_MM_ZIERLEISTENVAR_BS", this
                    .functionsContext).value.value;
            },
            zierleistenVariantGBSChanged: function () {
                const _this = this;
                return _this.getRegisteredCharacteristicsValue("KTU_MM_ZIERLEISTENVAR_GBS", this
                    .functionsContext).value.value;
            },
            zierleistenVarianteBsChanged: function () {
                const _this = this;
                return _this.getRegisteredCharacteristicsValue('KTU_MM_ZIERLEISTENVAR_BS', this
                    .functionsContext).value.value;
            },
            zierleistenVarianteGbsChanged: function () {
                const _this = this;
                return _this.getRegisteredCharacteristicsValue('KTU_MM_ZIERLEISTENVAR_GBS', this
                    .functionsContext).value.value;
            },
            // resources
            doorOpeningWayResource: function () {
                const _this = this;
                const filter = _this.getCurrentDoorConfiguration.GetResourceDependenciesByCharacteristic(
                    'KTU_MM_AUFGEHRICHTUNG', DependenciesFilter.Resources);
                if (filter.dependencieNotCompleted === true) {
                    return '';
                }
                return filter.dependenciesStr;
            },
            falzgeometrieResource: function () {
                const _this = this;
                const filter = _this.getCurrentDoorConfiguration.GetResourceDependenciesByCharacteristic(
                    'KTU_MM_FALZGEOMETRIE', DependenciesFilter.Resources);
                if (filter.dependencieNotCompleted === true) {
                    return '';
                }
                return filter.dependenciesStr;
            },
            zierleistenArtResource: function () {
                const _this = this;
                const filter = _this.getCurrentDoorConfiguration.GetResourceDependenciesByCharacteristic(
                    'KTU_MM_ZIERLEISTENART', DependenciesFilter.Resources);
                if (filter.dependencieNotCompleted === true) {
                    return '';
                }
                return filter.dependenciesStr;
            },
            zierleistenVariantBSResource: function () {
                const _this = this;
                const filter = _this.getCurrentDoorConfiguration.GetResourceDependenciesByCharacteristic(
                    'KTU_MM_ZIERLEISTENVAR_BS', DependenciesFilter.Resources);
                if (filter.dependencieNotCompleted === true) {
                    return '';
                }
                return filter.dependenciesStr;
            },
            zierleistenVariantGBSResource: function () {
                const _this = this;
                const filter = _this.getCurrentDoorConfiguration.GetResourceDependenciesByCharacteristic(
                    'KTU_MM_ZIERLEISTENVAR_GBS', DependenciesFilter.Resources);
                if (filter.dependencieNotCompleted === true) {
                    return '';
                }
                return filter.dependenciesStr;
            }
        },
        watch: {
            zierleistenVarianteBsChanged(zierleistenVarianteBsChanged) {
                const _this = this;
                this.filterDependencies('KTU_MM_ZIERLEISTENVAR_O_BS');
            },
            zierleistenVarianteGbsChanged(zierleistenVarianteGbsChanged) {
                const _this = this;
                this.filterDependencies('KTU_MM_ZIERLEISTENVAR_O_GBS');
            },
            zierleistenArtChanged(zierleistenArtChanged) {
                this.filterDependencies('CUST_MM_AUFDOPPLUNG');
                this.filterDependencies('KTU_MM_AUFDOPPELUNG_BS');
                this.filterDependencies('KTU_MM_AUFDOPPELUNG_GBS');
            },
            zierleistenVariantBSChanged(zierleistenVariantBSChanged) {
                this.filterDependencies('KTU_MM_AUFDOPPELUNG_BS');
            },
            zierleistenVariantGBSChanged(zierleistenVariantGBSChanged) {
                this.filterDependencies('KTU_MM_AUFDOPPELUNG_GBS');
            },
            doorOpeningWayResource(filter) {
                if (filter !== '') {
                    this.doorOpeningWayImageResource(filter);
                }
            },
            falzgeometrieResource(filter) {
                if (filter !== '') {
                    this.falzgeometrieImageResource(filter);
                }
            },
            zierleistenArtResource(filter) {
                if (filter !== '') {
                    this.zierleistenArtImageResource(filter);
                }
            },
            zierleistenVariantBSResource(filter) {
                if (filter !== '') {
                    this.zierleistenVariantBSImageResource(filter);
                }
            },
            zierleistenVariantGBSResource(filter) {
                if (filter !== '') {
                    this.zierleistenVariantGBSImageResource(filter);
                }
            },
        },

        methods: {
            ...mapActions('configuratorModule', ['updateDoorConfiguration', 'setMainNavigationItems',
                'setMainNavActiveId', 'incrementMainNavActiveId'
            ]),
            ...mapActions('functionsModule', ['calculateSchallschutzSonder']),
            toggleModal(state) {
                this.showModal = state;
            },
            settingsNavigation(index) {
                this.active = index;
                this.showSettingsContent = index;
            },
            changeDescriptionValue(data) {
                var filteredData = [];
                data.map(function(item) {
                    filteredData.push({id : item['id'], value: item['value'], description: item['description'].substring(2), resource: item['resource'], default: item['default']});
                })
                return filteredData;
            },
            imageResourcesMounted: function () {
                const _this = this;
                // const filter = _this.getCurrentDoorConfiguration.GetResourceDependenciesByCharacteristic(
                //     'KTU_MM_AUFGEHRICHTUNG', DependenciesFilter.Resources);
                // if (filter.dependencieNotCompleted === false) {
                //     this.doorOpeningWayImageResource(filter.dependenciesStr);
                // }

                // const filter1 = _this.getCurrentDoorConfiguration.GetResourceDependenciesByCharacteristic(
                //     'KTU_MM_FALZGEOMETRIE', DependenciesFilter.Resources);
                // if (filter1.dependencieNotCompleted === false) {
                //     this.falzgeometrieImageResource(filter1.dependenciesStr);
                // }
                //
                // const filter2 = _this.getCurrentDoorConfiguration.GetResourceDependenciesByCharacteristic(
                //     'KTU_MM_ZIERLEISTENART', DependenciesFilter.Resources);
                // if (filter2.dependencieNotCompleted === false) {
                //     this.zierleistenArtImageResource(filter2.dependenciesStr);
                // }
                //
                // const filter3 = _this.getCurrentDoorConfiguration.GetResourceDependenciesByCharacteristic(
                //     'KTU_MM_ZIERLEISTENVAR_BS', DependenciesFilter.Resources);
                // if (filter3.dependencieNotCompleted === false) {
                //     this.zierleistenVariantBSImageResource(filter3.dependenciesStr);
                // }
                //
                // const filter4 = _this.getCurrentDoorConfiguration.GetResourceDependenciesByCharacteristic(
                //     'KTU_MM_ZIERLEISTENVAR_GBS', DependenciesFilter.Resources);
                // if (filter4.dependencieNotCompleted === false) {
                //     this.zierleistenVariantGBSImageResource(filter4.dependenciesStr);
                // }
            },
            doorOpeningWayImageResource: function (filter) {
                const _this = this;
                var resource = resourcesService.getResourcesByDependencies(filter);

                resource.then(function (result) {
                    _this.doorOpeningWayImage = result.data[0];
                })
            },
            falzgeometrieImageResource: function (filter) {
                const _this = this;
                var resource = resourcesService.getResourcesByDependencies(filter);

                resource.then(function (result) {
                    _this.falzgeometrieImage = result.data[0];
                })
            },
            zierleistenArtImageResource: function (filter) {
                const _this = this;
                var resource = resourcesService.getResourcesByDependencies(filter);

                resource.then(function (result) {
                    const resources = result.data;
                    if (resources.length > 0) {
                        _this.zierleistenArtImage = resources[resources.length - 1];
                    } else {
                        _this.zierleistenArtImage.resourceLocation = '';
                    }
                })
            },
            zierleistenVariantBSImageResource: function (filter) {
                const _this = this;
                var resource = resourcesService.getResourcesByDependencies(filter);

                resource.then(function (result) {
                    const resources = result.data;
                    if (resources.length > 0) {
                        _this.zierleistenVariantBSImage = resources[0];
                    } else {
                        _this.zierleistenVariantBSImage.resourceLocation = '';
                    }
                })
            },
            zierleistenVariantGBSImageResource: function (filter) {
                const _this = this;
                var resource = resourcesService.getResourcesByDependencies(filter);

                resource.then(function (result) {
                    const resources = result.data;
                    if (resources.length > 0) {
                        _this.zierleistenVariantGBSImage = resources[0];
                    } else {
                        _this.zierleistenVariantGBSImage.resourceLocation = '';
                    }
                })
            },
            getCharacteristics() {
                NProgress.start();
                this.nextSaveBtnDisabled = true
                this.axios.get('api/functions').then(response => {
                    this.$store.dispatch('functionsModule/setFunctionsCharacteristics', response.data);
                    this.addSingleCharacteristicsFileredOrDefaults().then(async () => {
                        await this.setInitialDependencies();
                        this.imageResourcesMounted();
                        this.initGlass();
                    }).finally(() => {
                        NProgress.done()
                        this.nextSaveBtnDisabled = false
                    });
                });
            },
            async setInitialDependencies() {
                await this.filterDependencies('KTU_MM_AUFGEHRICHTUNG');
                //Get images on mount after char value set
                const filter = this.getCurrentDoorConfiguration.GetResourceDependenciesByCharacteristic(
                    'KTU_MM_AUFGEHRICHTUNG', DependenciesFilter.Resources);
                if (filter.dependencieNotCompleted === false) {
                    this.doorOpeningWayImageResource(filter.dependenciesStr);
                }

                await this.filterDependencies('KTU_MM_FALZGEOMETRIE');
                const filter1 = this.getCurrentDoorConfiguration.GetResourceDependenciesByCharacteristic(
                    'KTU_MM_FALZGEOMETRIE', DependenciesFilter.Resources);
                if (filter1.dependencieNotCompleted === false) {
                    this.falzgeometrieImageResource(filter1.dependenciesStr);
                }

                const filter2 = this.getCurrentDoorConfiguration.GetResourceDependenciesByCharacteristic(
                    'KTU_MM_ZIERLEISTENART', DependenciesFilter.Resources);
                if (filter2.dependencieNotCompleted === false) {
                    this.zierleistenArtImageResource(filter2.dependenciesStr);
                }

                await this.filterDependencies('KTU_MM_SCHLAGL_ANZ_BS');
                await this.filterDependencies('KTU_MM_SCHLAGL_ANZ_GBS');
                await this.filterDependencies('CUST_MM_SCHLAGL_ANZ_W_BS');
                await this.filterDependencies('CUST_MM_SCHLAGL_ANZ_W_GBS');
                await this.filterDependencies('CUST_MM_RH_DICHTUNG');
                await this.filterDependencies('KTU_MM_GLASART');
                await this.filterDependencies('KTU_MM_FUNKTION_BESCHUSS');
                await this.filterDependencies('KTU_MM_ZIERLEISTENVAR_BS');
                const filter3 = this.getCurrentDoorConfiguration.GetResourceDependenciesByCharacteristic(
                    'KTU_MM_ZIERLEISTENVAR_BS', DependenciesFilter.Resources);
                if (filter3.dependencieNotCompleted === false) {
                    this.zierleistenVariantBSImageResource(filter3.dependenciesStr);
                }

                await this.filterDependencies('KTU_MM_ZIERLEISTENVAR_GBS');
                const filter4 = this.getCurrentDoorConfiguration.GetResourceDependenciesByCharacteristic(
                    'KTU_MM_ZIERLEISTENVAR_GBS', DependenciesFilter.Resources);
                if (filter4.dependencieNotCompleted === false) {
                    this.zierleistenVariantGBSImageResource(filter4.dependenciesStr);
                }

                await this.filterDependencies('KTU_MM_GLASVARIANTE');
                await this.filterDependencies('KTU_MM_ZIERLEISTENVAR_O_BS');
                await this.filterDependencies('KTU_MM_ZIERLEISTENVAR_O_GBS');
                await this.filterDependencies('KTU_MM_GLASVARIANTE_O');
                await this.filterDependencies('CUST_MM_FLUCHT_PANIK');
                await this.filterDependencies('CUST_MM_AUFDOPPLUNG');
                await this.filterDependencies('KTU_MM_AUFDOPPELUNG_BS');
                await this.filterDependencies('KTU_MM_AUFDOPPELUNG_GBS');
                await this.filterDependencies('KTU_MM_D2_GES');
                await this.filterDependencies('CUST_MM_MINDESTBESTANDSSTARKE');
                await this.filterDependencies('KTU_MM_ZIERLEISTEN');
                await this.filterDependencies('KTU_MM_SCHLAGL_ANZ_W_BS');
                await this.filterDependencies('KTU_MM_SCHLAGL_ANZ_W_GBS');
                await this.filterDependencies('KTU_MM_FUNKTION_EN1125');
                await this.filterDependencies('KTU_MM_FUNKTION_EN179');
            },
            async filterDependencies(characteristicCode) {
                await this.$store.dispatch('functionsModule/setCharacteristicDependencies', characteristicCode);
                if(characteristicCode === 'KTU_MM_GLASVARIANTE') {
                    this.initGlass();
                }
            },
            addCharacterisitc(e, characteristic) {
                //to be tested
                // let valueDefinition = e

                const selectedCharacteristic = MapCharacteristicAndValue(characteristic, e);
                this.doorConfiguration = this.getCurrentDoorConfiguration;
                this.doorConfiguration.Add(DoorConfiguration.Functions, selectedCharacteristic);
                this.$store.dispatch('configuratorModule/updateDoorConfiguration', this.doorConfiguration);
            },
            initGlass() {
                let glassArtValue = this.getRegisteredCharacteristicsValue('KTU_MM_GLASART', this.functionsContext).value.value;

                if(this.isGlassWingSelected && !this.isTwoWingDoor) {
                    let activeLeafGlassValues = this.getCharacteristicAndValues('KTU_MM_GLAS_GEHFLUEGEL').values;
                    let valueToSetActiveLeafGlass = activeLeafGlassValues.find(x => x.value === glassArtValue);
                    this.addCharacterisitc(valueToSetActiveLeafGlass, this.getCharacteristicAndValues('KTU_MM_GLAS_GEHFLUEGEL'));

                    let standingLeafGlassValues = this.getCharacteristicAndValues('KTU_MM_GLAS_STEHFLUEGEL').values;
                    let valueToSetStandingLeafGlass = standingLeafGlassValues.find(x => x.value === '0');
                    this.addCharacterisitc(valueToSetStandingLeafGlass, this.getCharacteristicAndValues('KTU_MM_GLAS_STEHFLUEGEL'));
                }
                else if(this.isGlassWingSelected && this.isTwoWingDoor) {
                    let activeLeafGlassValues = this.getCharacteristicAndValues('KTU_MM_GLAS_GEHFLUEGEL').values;
                    let valueToSetActiveLeafGlass = activeLeafGlassValues.find(x => x.value === glassArtValue);
                    this.addCharacterisitc(valueToSetActiveLeafGlass, this.getCharacteristicAndValues('KTU_MM_GLAS_GEHFLUEGEL'));

                    let standingLeafGlassValues = this.getCharacteristicAndValues('KTU_MM_GLAS_STEHFLUEGEL').values;
                    let valueToSetStandingLeafGlass = standingLeafGlassValues.find(x => x.value === glassArtValue);
                    this.addCharacterisitc(valueToSetStandingLeafGlass, this.getCharacteristicAndValues('KTU_MM_GLAS_STEHFLUEGEL'));
                }
                else {
                    let activeLeafGlassValues = this.getCharacteristicAndValues('KTU_MM_GLAS_GEHFLUEGEL').values;
                    let valueToSetActiveLeafGlass = activeLeafGlassValues.find(x => x.value === '0');
                    this.addCharacterisitc(valueToSetActiveLeafGlass, this.getCharacteristicAndValues('KTU_MM_GLAS_GEHFLUEGEL'));

                    let standingLeafGlassValues = this.getCharacteristicAndValues('KTU_MM_GLAS_STEHFLUEGEL').values;
                    let valueToSetStandingLeafGlass = standingLeafGlassValues.find(x => x.value === '0');
                    this.addCharacterisitc(valueToSetStandingLeafGlass, this.getCharacteristicAndValues('KTU_MM_GLAS_STEHFLUEGEL'));

                    this.valueAddCharacteristic(0, this.getCharacteristicAndValues('KTU_MM_GLAS_G_HOEHE'));
                    this.valueAddCharacteristic(0, this.getCharacteristicAndValues('KTU_MM_GLAS_G_BREITE'));
                    this.valueAddCharacteristic(0, this.getCharacteristicAndValues('KTU_MM_GLAS_S_HOEHE'));
                    this.valueAddCharacteristic(0, this.getCharacteristicAndValues('KTU_MM_GLAS_S_BREITE'));
                }

                if(this.hasDoorTopPanel && this.isTopPanelGlassSelected) {
                    let topPanelGlassValues = this.getCharacteristicAndValues('KTU_MM_GLAS_OBERBLENDE').values;
                    let valueToSetTopPanelGlass = topPanelGlassValues.find(x => x.value === glassArtValue);
                    this.addCharacterisitc(valueToSetTopPanelGlass, this.getCharacteristicAndValues('KTU_MM_GLAS_OBERBLENDE'));
                }else {
                    let topPanelGlassValues = this.getCharacteristicAndValues('KTU_MM_GLAS_OBERBLENDE').values;
                    let valueToSetTopPanelGlass = topPanelGlassValues.find(x => x.value === '0');
                    this.addCharacterisitc(valueToSetTopPanelGlass, this.getCharacteristicAndValues('KTU_MM_GLAS_OBERBLENDE'));
                    this.valueAddCharacteristic(0, this.getCharacteristicAndValues('KTU_MM_GLAS_O_HOEHE'));
                    this.valueAddCharacteristic(0, this.getCharacteristicAndValues('KTU_MM_GLAS_O_BREITE'));
                }
            },
            resetModelSelection() {
                this.doorConfiguration = this.getCurrentDoorConfiguration;
                this.doorConfiguration.ClearConfiguration(DoorConfiguration.Functions);
                this.$store.dispatch('configuratorModule/updateDoorConfiguration', this.doorConfiguration);
                let mainNav = new MainNavigationFilter(this.getMainNav);
                let mainNavItems = mainNav.ResetMainNavigationItemStatus(this.windowMainNavId, false);
                this.setMainNavigationItems(mainNavItems);
            },
            nextStep() {
                let mainNav = new MainNavigationFilter(this.getMainNav);
                let mainNavItems = mainNav.UpdateMainNavigation(this.getFuncItems, this.windowMainNavId +
                    1);
                this.setMainNavigationItems(mainNavItems);
                const nextMainNavItem = mainNavItems.filter(x => x.itemId == this.windowMainNavId + 1)[0];
                if (nextMainNavItem.disabled == false) {
                    /* this.setMainNavActiveId(this.windowMainNavId + 1); */
					const activeMainNavIndex = this.getMainNav.findIndex(f => f.itemId === this.windowMainNavId)
                    this.incrementMainNavActiveId(activeMainNavIndex);
					this.$EventBus.$emit('triggerMaxHeight')
                    this.$router.push('/product-configurator' + nextMainNavItem.route);
                } else {
                    console.log('Functions step not completed!');
                }
            },
            valueAddCharacteristic(e, characteristicValue) {
                // to be tested
                let value = e

                characteristicValue.values[0].value = value;
                const selectedCharacteristic = MapCharacteristicAndValue(characteristicValue,
                    characteristicValue.values[0]);
                this.doorConfiguration = this.getCurrentDoorConfiguration;
                this.doorConfiguration.AddNumericCharacteristic(DoorConfiguration.Functions,
                    selectedCharacteristic);
                this.$store.dispatch('configuratorModule/updateDoorConfiguration', this.doorConfiguration);
                this.checkCalculatedCharacteristics(selectedCharacteristic.code);
            },
            checkCalculatedCharacteristics(characteristicCode) {
                if (characteristicCode === 'KTU_MM_ZIERLEISTENART' ||
                    characteristicCode === 'KTU_MM_ZIERLEISTENVAR_BS' ||
                    characteristicCode === 'KTU_MM_ZIERLEISTENVAR_GBS') {
                    this.$store.dispatch('functionsModule/setConfiguratorCalculatedCharacteristics');
                }
            },
            CheckForNumericValues() {
                let wanddickeCharacteristic = this.getCurrentDoorConfiguration.Get(DoorConfiguration.Functions)
                    .filter((x) => x.code === 'KTU_MM_WANDDICKE')[0];
                if (typeof wanddickeCharacteristic !== 'undefined') {
                    this.KTU_MM_WANDDICKE_Value = wanddickeCharacteristic.value.value;
                } else {
                    this.KTU_MM_WANDDICKE_Value = 0;
                }
            },
            getAppropValue(characteristicCode) {
                let characteristic = this.getCharacteristicAndValues(characteristicCode);
                let registeredCharacteristic = this.getRegisteredCharacteristicsValue(characteristicCode, this
                    .functionsContext);
                let valueDefinition;
                if (characteristic.values.length > 1) {
                    valueDefinition = characteristic.values.filter((x) => x.id !== registeredCharacteristic
                        .value.id)[0];
                } else {
                    valueDefinition = characteristic.values[0];
                }
                const selectedCharacteristic = MapCharacteristicAndValue(characteristic, valueDefinition);
                return selectedCharacteristic;
            },
            async addSingleCharacteristicsFileredOrDefaults() {
                this.getFunctionsCharacteristics.forEach((char) => {
                    if (char.values.length == 1) {
                        const selectedCharacteristic = MapCharacteristicAndValue(char, char.values[
                            0]);
                        this.doorConfiguration = this.getCurrentDoorConfiguration;
                        this.doorConfiguration.Add(DoorConfiguration.Functions,
                            selectedCharacteristic);
                        this.$store.dispatch('configuratorModule/updateDoorConfiguration', this
                            .doorConfiguration);
                    } else {
                        let regChar = this.getRegisteredCharacteristicsValue(char.code, this
                            .functionsContext);
                        let exists = regChar.id === char.id;
                        let registeredValue = char.values.filter((x) => x.id === regChar.value.id)[
                            0];
                        let incorrectValue = typeof registeredValue === 'undefined' ? true : false;
                        if (exists === false || incorrectValue === true) {
                            let valueItem = char.values[0];
                            const selectedCharacteristic2 = MapCharacteristicAndValue(char,
                                valueItem);
                            this.doorConfiguration = this.getCurrentDoorConfiguration;
                            this.doorConfiguration.Add(DoorConfiguration.Functions,
                                selectedCharacteristic2);
                            this.$store.dispatch('configuratorModule/updateDoorConfiguration', this
                                .doorConfiguration);
                        }
                    }
                });
            },
            checkBoxAdd(characteristicCode) {
                let chart = this.getAppropValue(characteristicCode);
                this.doorConfiguration = this.getCurrentDoorConfiguration;
                this.doorConfiguration.Add(DoorConfiguration.Functions, chart);
                this.$store.dispatch('configuratorModule/updateDoorConfiguration', this.doorConfiguration);
            },
            checkFluchtPanic(characteristicCode) {
                const fluchT = this.getRegisteredCharacteristicsValue('CUST_MM_FUNKTION_EN179', this
                    .functionsContext).value.value;
                const panikT = this.getRegisteredCharacteristicsValue('CUST_MM_FUNKTION_EN1125', this
                    .functionsContext).value.value;
                if (characteristicCode === 'CUST_MM_FUNKTION_EN179') {
                    if (panikT === 'JA' && fluchT === 'NEIN') {
                        let chart1 = this.getAppropValue('CUST_MM_FUNKTION_EN1125');
                        this.doorConfiguration = this.getCurrentDoorConfiguration;
                        this.doorConfiguration.Add(DoorConfiguration.Functions, chart1);
                        this.$store.dispatch('updateDoorConfiguration', this.doorConfiguration);
                    }
                } else {
                    if (fluchT === 'JA' && panikT === 'NEIN') {
                        let chart2 = this.getAppropValue('CUST_MM_FUNKTION_EN179');
                        this.doorConfiguration = this.getCurrentDoorConfiguration;
                        this.doorConfiguration.Add(DoorConfiguration.Functions, chart2);
                        this.$store.dispatch('updateDoorConfiguration', this.doorConfiguration);
                    }
                }
            },
            checkStatusOfControl(anchorCharacteristicCode, characteristicCode, valueCode) {
                let numberOfValues = this.getNrOfValuesByCharacteristic(anchorCharacteristicCode);
                if (numberOfValues === 1) {
                    return true;
                }
                const registredChar = this.getRegisteredCharacteristicsValue(characteristicCode, this
                    .functionsContext);
                if (typeof registredChar !== 'undefined') {
                    if (registredChar.value.value === valueCode) {
                        return true;
                    } else {
                        return false;
                    }
                } else {
                    return false;
                }
            },
            handleSchallschutzSonderSelect(valueDefinition){
                this.addCharacterisitc(valueDefinition, this.getCharacteristicAndValues('CUST_MM_SCHALLSCHUTZ_PLUS'))
                this.calculateSchallschutzSonder();
            },
            recalcBodyHeight(){
                //calculation of top-bar height 
                if(this.$refs.topBar.clientHeight != this.bodyCalcHeight)
                    this.bodyCalcHeight = this.$refs.topBar.clientHeight;
            }
        },
        created() {
            window.addEventListener("resize", this.recalcBodyHeight);
        },
        destroyed() {
            window.removeEventListener("resize", this.recalcBodyHeight);
        },
        mounted() {
            this.getCharacteristics();
            this.$store.dispatch('functionsModule/setConfiguratorCalculatedCharacteristics');
            //calculation of top-bar height
            this.bodyCalcHeight = this.$refs.topBar.clientHeight;
        },
        updated() {
            this.addSingleCharacteristicsFileredOrDefaults();
            // Calculates Automatically characteristics
            this.$store.dispatch('functionsModule/setConfiguratorCalculatedCharacteristics');
        },

    });
</script>
<style lang="scss" scoped>
    .main-row-fill-height {
        height: 100%;
        margin-left: 0;
        margin-right: 0;

        >.col {
            max-height: 100%;
        }
    }
    .image_d0f0d6ef {
        width:80%;
        display: block;
        margin-left: auto;
        margin-right: auto;
    }
    .image_79a9330b {
        width:60%;
        display: block;
        margin-left: auto;
        margin-right: auto;
    }
    .fit_image_a70d4293 {
        margin-top:30px;
        height: 400px;
        width: 35%;
        display: block;
        margin-left: auto;
        margin-right: auto;
        overflow: hidden;
        }
    .image_a70d4293 {
        height: auto;
        width:  100%;
        object-fit: cover;
        display: block;
        margin-left: auto;
        margin-right: auto;
    }
    .image_fc93ba86 {
        width:60%;
        display: block;
        margin-left: auto;
        margin-right: auto;
    }
    .image_a0618669 {
        width:80%;
        display: block;
        margin-left: auto;
        margin-right: auto;
    }
</style>